import { render, staticRenderFns } from "./departament-view.vue?vue&type=template&id=39265aa4&"
import script from "./departament-view.vue?vue&type=script&lang=js&"
export * from "./departament-view.vue?vue&type=script&lang=js&"
import style0 from "./departament-view.vue?vue&type=style&index=0&id=39265aa4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports